import { render, staticRenderFns } from "./stuffInformation.vue?vue&type=template&id=135d43dd&scoped=true"
import script from "./stuffInformation.vue?vue&type=script&lang=js"
export * from "./stuffInformation.vue?vue&type=script&lang=js"
import style0 from "./stuffInformation.vue?vue&type=style&index=0&id=135d43dd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d43dd",
  null
  
)

export default component.exports